import {html, render, SingleEvent} from "#Shared/Lit";
import {DateUtilities} from "./DateUtilities";
import {WpAjaxPost} from "./WpAjaxPost";
declare var rnappointmentVar;
export interface IAppointmentFieldOptions{
    Format:string;
    FirstDayOfWeek:number;
    LongDateFormat:string;
    Intervals:any;
    MinDate:string;
    MaxDate:string;
    Holidays:any[];
    AppointmentDuration:number;
    TimeFormat:string;
    Placeholder:string;
}

declare var flatpickr:any;
declare var jQuery:any;
declare var ajaxurl;
declare function RNTranslate(param1);
export class AppointmentFieldModel {
    public Options:IAppointmentFieldOptions;
    public Date:number=null;
    public flatPickr:any=null;
    public CalendarDate:Date;
    public LoadingCounter:number=0;
    public AvailableSlots:any[]=[];
    public OnRefresh:SingleEvent=new SingleEvent<any>();

    constructor(public FieldId:string,options:any,public FormID:string='') {
        this.Options=options;
        this.Date=null;
        this.CalendarDate=new Date();

        let unix=0;
        this.LoadAvailableDates();
        this.AvailableSlots=[];
    }
    render() {
        return html`<rnappointment-appointment-field .model="${this}"></rnappointment-appointment-field>`
    }

    public SetDate(value:number)
    {
        if(value===0)
            value=null;
        this.Date=value;

        (document.getElementById('wpforms-'+this.FormID+'-field_'+this.FieldId) as HTMLInputElement).value=JSON.stringify({
            'Format':this.GetFormattedDate(),
            'Unix':this.Date
        })
        this.Refresh();
    }

    GetValue() {
        return this.Date;
    }


    SetFlatPickr(flatpickr: any) {
        this.flatPickr=flatpickr;
        this.Refresh();
    }

    public Refresh() {
        this.OnRefresh.Publish();
    }

    public GetDate(){
        if(this.Date!=null)
            return DateUtilities.UnixToDate(this.Date);
        return null;
    }

    GetFormattedDate() {
        if(this.Date===null)
            return '';

        let date=DateUtilities.UnixToDate(this.Date);
        let timeFormat='';
        if(this.Options.TimeFormat=='24')
            timeFormat='H:i';
        else
            timeFormat='h:i K';

        return `${flatpickr.formatDate(date,timeFormat,rnappointmentVar.Locale)} ${RNTranslate('on')} ${flatpickr.formatDate(date,this.Options.LongDateFormat,rnappointmentVar.Locale)}`;
    }




    public async LoadAvailableDates() {
        if(this.CalendarDate==null)
            return;

        let result=null;
        this.AvailableSlots=[];
        this.LoadingCounter++;
        let counterToUse = this.LoadingCounter;


        let endDate = new Date(this.CalendarDate.getFullYear(), this.CalendarDate.getMonth() + 1, 1);
        jQuery.post(rnappointmentVar.ajaxurl, {
            action: 'formwiz_appointment_get_dates',
            'Options': JSON.stringify(this.Options),
            StartDate: this.CalendarDate.getFullYear() + '/' + (this.CalendarDate.getMonth() + 1) + '/01',
            EndDate: endDate.getFullYear() + '/' + (endDate.getMonth() + 1) + '/01'
        },(result)=>{
            result=JSON.parse(result);
            if(counterToUse!=this.LoadingCounter)
                return;

            if (result != null)
                this.AvailableSlots = result;

            if(this.flatPickr==null)
                return;
            this.flatPickr.redraw();
            this.Refresh();
        })





    }

    GetFormattedCalendarDate() {
        return flatpickr.formatDate(this.CalendarDate,this.Options.LongDateFormat,rnappointmentVar.Locale);
    }


    GetSlotsByDate(date: Date) :{From:number,To:number,Label:string,Date:number}[]{
        if(date==null)
            return [];
        let dateLabel=date.getFullYear()+'/'+(date.getMonth()+1)+'/'+date.getDate();
        return this.AvailableSlots[dateLabel]??[];
    }

    Render() {
        let container=document.querySelector('.appointmentItem_'+this.FieldId);
        render(html`<rnappointment-appointment-field .model="${this}"></rnappointment-appointment-field>`,container as any);
    }
}